define('services/fileUploadService',[
    'config',
    'jquery',
    'lib/bluebird',
    'lib/knockout',
    'lib/lodash4',
    'models/Upload',
    'services/activeRequestTracker',
    'util/HttpError'
], function (
    config,
    $,
    Promise,
    ko,
    _,
    Upload,
    requestTracker,
    HttpError
) {
    'use strict';

    
    var activeUploads = ko.observableArray([]);
    var oAuthBearerToken;

    function updateProgress(progressTracker, progressEvent) {
        if (progressTracker.upload) {
            progressTracker.upload.bytesUploaded(progressEvent.loaded);
            progressTracker.upload.totalBytes(progressEvent.total);
        }
    }

    function generateFormData(fileData, metadata) {
        var data = new FormData();

        data.append('file', fileData);
        _(metadata).each(function (value, key) {
            data.append(key, value);
        });

        return data;
    }

    /** upload v2 */
    function upload(path, fileData, metadata) {
        var uploadRoot = config.uploadService.uri;
        var uploadUrl = uploadRoot + path;
        return handleUpload(uploadUrl, fileData, metadata);
    }

    /** v4 is the endpoint to use if you implemented an extension in upload service */
    function uploadv4(path, fileData, metadata) {
        var uploadRoot = config.uploadServicev4.uri;
        var uploadUrl = uploadRoot + path;
        return handleUpload(uploadUrl, fileData, metadata);
    }

    function handleUpload(url, fileData, metadata) {

        var progressTracker = {};

        var headers = {};
        if (oAuthBearerToken) {
            headers.Authorization = 'bearer ' + oAuthBearerToken;
        }

        var progress_xhr;
        var xhr = $.ajax({
            url: url,
            type: 'POST',
            headers: headers,
            xhr: function () {
                progress_xhr = new XMLHttpRequest();
                progress_xhr.upload.addEventListener('progress', _.bind(updateProgress, null, progressTracker), false);
                return progress_xhr;
            },
            xhrFields: {
                withCredentials: true
            },
            data: generateFormData(fileData, metadata),
            processData: false,
            contentType: false
        });

        var promise = Promise.cast(xhr).cancellable()
            .catch(function (error) {
                if (error.name === "CancellationError") {
                    xhr.abort();
                    return Promise.reject(error);
                } else {
                    return Promise.reject(new HttpError(error));
                }
            })
            .finally(function () {
                activeUploads.remove(progressTracker.upload);
            });

        requestTracker.addRequest(promise);
        progressTracker.upload = new Upload(promise, metadata);

        activeUploads.push(progressTracker.upload);

        return progressTracker.upload;
    }


    /**
     * File upload service. Handles uploading files with progress
     *
     * Usage:
     *
     * var upload = fileUploadService.post(uploadPath, fileData, fileMetadata)
     *                  .then(function(){
     *                      //upload completed
     *                  })
     *                  .catch(function() {
     *                      //upload error
     *                  });
     *
     * fileData should be of Blob or File type.
     * fileMetadata is optional
     */
    var service =  {
        activeUploads: activeUploads,

        /**
         * Upload a file using POST
         * @param uri
         * @param data
         * @param uploadProgress Model
         */
        upload: function (path, fileData, metadata) {
            return upload(path, fileData, metadata);
        },

        uploadv4: function (path, fileData, metadata) {
            return uploadv4(path, fileData, metadata);
        },

        setOauthBearerToken: function(bearerToken) {
            oAuthBearerToken = bearerToken;
        }
    };

    return service;
});

